export default __webpack_public_path__ + "static/media/hospitableLogo.0a941274.svg";